// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "aigcexchange/css/" + chunkId + "." + {"1972":"24285541","3876":"b80ad3cf","5002":"2bf7573b","6978":"2082eace","8708":"23015b48"}[chunkId] + ".css";
};